export default async function hashFromString(string) {
  const hash = await crypto.subtle.digest("SHA-256", (new TextEncoder()).encode(string))
  return btoa(String.fromCharCode(...new Uint8Array(hash)))
}
